import { MIN_SUPPORTED_PNPM_MAJOR } from '@cli-constants/tool-versions.js'

export function isSupportedPnpmPackageManager(packageManager: string): boolean {
  const pnpmVersionMatch = /^pnpm@(\d+)\.\d+\.\d+(?:[-+].+)?$/.exec(packageManager)
  return Boolean(pnpmVersionMatch && Number(pnpmVersionMatch[1]) >= MIN_SUPPORTED_PNPM_MAJOR)
}
